import { useState, useEffect } from "react";

interface WindowSize {
  width: number;
  height: number;
}

interface MobileDetectReturn {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  windowSize: WindowSize;
}

export const useMobileDetect = (): MobileDetectReturn => {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    
    // Function to update window size
    const handleResize = () => {
      const newSize = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      
      console.log('Window resized:', newSize);
      setWindowSize(newSize);
    };

    // Add event listener
    window.addEventListener("resize", handleResize);
    
    // Call handler right away for initial size
    handleResize();
    
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowSize.width < 768;
  const isTablet = windowSize.width >= 768 && windowSize.width < 1024;
  const isDesktop = windowSize.width >= 1024;

  // Log on value change for debugging
  useEffect(() => {
    console.log('useMobileDetect values:', { isMobile, isTablet, isDesktop, windowSize });
  }, [isMobile, isTablet, isDesktop, windowSize]);

  return {
    isMobile,
    isTablet,
    isDesktop,
    windowSize,
  };
};

export default useMobileDetect; 